import { render, staticRenderFns } from "./ElementTable.vue?vue&type=template&id=89ff9a8c&scoped=true"
import script from "./ElementTable.vue?vue&type=script&lang=js"
export * from "./ElementTable.vue?vue&type=script&lang=js"
import style0 from "./ElementTable.vue?vue&type=style&index=0&id=89ff9a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ff9a8c",
  null
  
)

export default component.exports